import { useContext } from 'react'
import { EditableWish } from './types'
import { LootContext, PersonalLootContext } from './context'
import { difficulties } from 'app/frontend/types/custom/Difficulty'

export const useFindRelevantWish = (currentSpecId: number) => {
  const { difficulty, configuration } = useContext(LootContext)
  const { changes } = useContext(PersonalLootContext)

  return (item: wowaudit.WishlistItem, isVoidforged = false) => {
    const wishId = `${item.id}-${difficulty}-${currentSpecId}-${configuration.id}`

    return (
      (!isVoidforged && changes[wishId]) ||
      item.wishes.find(
        (wish) =>
          wish.difficulty === difficulties.indexOf(difficulty) &&
          wish.specialization === currentSpecId &&
          configuration.id === wish.configuration_id &&
          !!wish.voidforged === isVoidforged,
      )
    )
  }
}

export const VOIDFORGED_ILVL: Record<number, number> = { 0: 298, 1: 285 }

// Wowhead bonus ids that render the Voidforged version of an item (difficulty
// index 0 = mythic, 1 = heroic).
export const VOIDFORGED_BONUS_ID: Record<number, number> = {
  0: 13654,
  1: 13653,
}

// Matched against the normalized `display_slot`, which folds the various weapon
// item types into one_hand / two_hand / ranged / off_hand.
export const VOIDFORGED_SLOTS = [
  'one_hand',
  'two_hand',
  'ranged',
  'off_hand',
  'trinket',
]

export const wishEmpty = (wish?: EditableWish) => {
  return !wish || wish.type === 'none'
}

export const levelColors = {
  huge: 'bg-destructive-foreground',
  big: 'bg-warning-foreground',
  small: 'bg-success-foreground',
  tiny: 'bg-muted-foreground',
  none: 'bg-transparent',
}
